export default __webpack_public_path__ + "static/media/thankYouGif.16a06632.gif";